import React, { useState, useEffect } from "react";
import classNames from "classnames";
import css from '../style.scss';
import { withRouter } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import downFullArrow from 'assets/images/account-page/down-full-arrow.svg'
import leadsmIcon from 'assets/images/account-page/lead-auto-sm-img.svg';
import LeaveMessagePopup from "../modals/LeaveMessage";
import { connect, useDispatch, useSelector } from "react-redux";
import userImg from 'assets/images/account-page/user-icon-lg.png';
import { selectSelectedTeamMember , selectUserId } from "data/user/selectors";
import { formatToLongDate, numberOfDaysFromToday } from "../../../utils/date/formatDate";
import { DowngradeMemberTeamAPI } from "data/user/actions";
import { getFullDataURL } from "./validationSchemas";

const TeamDowngrade = (props) => {
  const { type , memberId } = props.match.params;
   const [screenType, setscreenType] = useState(type);
  
   const dispatch = useDispatch();
   const teamMemberDetails = useSelector(selectSelectedTeamMember).toJS();
   const userId = useSelector(selectUserId)
 
     const [successful, setSuccessful] = useState(false); // Default selected plan
 
     useEffect(() => {
       if(screenType) {
        setscreenType(type)
       }
     }, [type])
     
 
   const handleCancel = () => {
    props.leaveMessagePopup({
        CancelRedirect: () => null, 
        yesRedirect: () =>  props.history.push("/accountnew/landing"),
      });
   }
 
   // const goToManageLeadAutomator = (type) => {
   //   props.history.push(`/accountnew/manageleadautomator/${type}`);
   // };
 
   const goToAccount = () => {
     props.history.push(`/accountnew/landing`);
   }
   
   const handleConfirmChanges = async () => {
    console.log("Changes confirmed!");
    const req = {    
      primaryUserID: Number(userId),
      teamMemberID: Number(memberId),
      type : "SCOUT",
      amount: 0
    }
    // props.history.push(`/accountnew/teamdowngrade/${memberId}/success`);
    // Enable after API works
    try {
      const response = await DowngradeMemberTeamAPI(req); // Await the async function
      if (response.success) {
        props.history.push(`/accountnew/teamdowngrade/${memberId}/success`);
        console.log("successful:", response.teamMember);
      } else {
        dispatch(LeaveMessagePopup.open({
          title: "Error",
          message: response.error,
          yesLable: "Ok",
          cancelLable: null,
          CancelRedirect: () => null,
          yesRedirect: () => null
        }))
      }
    } catch (error) {
      dispatch(LeaveMessagePopup.open({
        title: "Error",
        message: response.error,
        yesLable: "Ok",
        cancelLable: null,
        CancelRedirect: () => null,
        yesRedirect: () => null
      }))
    }
  };
 
   return (
     <>
       <div className={css.clsInnerMainBody}>
         <div className={css.clsInnerPage}>
            <div className="container">
             <div className={css.clsLAReviewPaySec}>
               <div className="row justify-content-center">
                 <div className="col-lg-4">
                  
                 <FromToSelectedTier 
                 teamMember={teamMemberDetails}
                   />
 
                 </div>
                 {screenType === 'review' ? (
                   <div className="col-lg-5">
                     <ReviewConfirmUnsubscribe teamMember={teamMemberDetails}  />
                 </div>
                 ) : (<SuccessfulFlow teamMember={teamMemberDetails} />)}
               </div>
             </div>
           </div>    
         </div>
 
         <div className={css.clsInnerFooter}>
 
         {screenType === 'review' ? (
            <>
            <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnPrimaryGreen)} onClick={() => handleCancel()}> Cancel </button>
            <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} onClick={handleConfirmChanges}> Confirm Changes</button>
            </>
         ) : (
           <button className={classNames(css.btn_xl, css.btn_primary, css.clsBtnOrng)} onClick={() =>goToAccount()}> Return to Account </button>
         ) }
         </div>
       </div> 
     </>
   );
 };
 
 
 
 const FromToSelectedTier = ({teamMember}) => {
   return (
     <div className={css.clsLAReviewPayCard}>
     <div className={css.clsLAReviewLeadAutoDetils}>
       <div className="d-flex align-items-center">
         <div className={css.clsProfileImg}> 
           {teamMember?.profilePicture ? (
              <img src={getFullDataURL(teamMember?.profilePicture)} width={30} height={30} className={classNames(css.mr_5px,css.profileImage)} alt="Profile" />
             ) : (
               <img src={userImg} alt="user" />
            )}
         </div>
         <h5 className={css.clsLAReviewLeadAutomatorTxt}>{teamMember?.fullName}</h5>
       </div>
     </div>
     <div className={css.clsLAReviewTier}>
       <h4 className={css.clsTxtLine1}>MEMBER TIER</h4>
       <h4 className={css.clsTxtLine2}>Team Member</h4>
     </div>
     <div className="text-center">
       <ReactSVG src={downFullArrow} className={classNames(css.mb_16, css.mt_16)} />
     </div>
     <div className={css.clsLAReviewTier}>
       <h4 className={css.clsTxtLine1}>MEMBER TIER</h4>
       <h4 className={css.clsTxtLine2}>Scout</h4>
     </div>
   </div>
   )
 }
 
 const ReviewConfirmUnsubscribe = (props) => {

  const {teamMember} = props

   return (
     <div className={css.clsLAReviewPayCard2}>
     <h3 className={css.clsLAReviewHeading}>Review And Confirm Changes</h3>
     <div className={css.clsLAReviewPayTimelineContainer}>
       <div className={css.clsLAReviewPayTimeline}>
         <div className={css.clsLATimelineItem}>
           <div className={css.clsLATimelineDot}></div>
           <div className={css.clsLATimelineContent}>
             <div className={css.clsLATimelineHead}>
               <h4 className={css.clsLATimelineLabel}>Today</h4>
             </div>
             <p className={css.clsLATimelineDescription}>{numberOfDaysFromToday(teamMember?.billDate)} days remaining for Team Member’s full-access privileges</p>
           </div>
         </div>
 
         <div className={css.clsLATimelineLine2TMdowngrade}></div>
 
         <div className={css.clsLATimelineItem}>
           <div className={css.clsLATimelineDot}></div>
           <div className={css.clsLATimelineContent}>
             <div className={css.clsLATimelineHead}>
               <h4 className={css.clsLATimelineLabel}>Starting {formatToLongDate(teamMember?.billDate)}</h4>
             </div>
             <p className={classNames(css.clsLATimelineDescription,css.clsLATimelineDescriptionTMdowngrade)}>Team Member loses full-access privileges</p>
           </div>
         </div> 
       </div>
     </div>
     <div className={css.clsLAReviewContentPara}>
       <p className={css.clsPara}>
         By clicking “Confirm Changes” you agree to the <a target="_blank"  href="https://www.propstream.com/terms-of-use" className={css.terms_conditions}>PropStream Terms and Conditions.</a>
       </p>
     </div>
   </div>
   )
 }
 
 
 const SuccessfulFlow = (props) => {

  const {teamMember} = props

   return (
     <div className={css.clsLAReviewPayCard2}>
       <h3 className={css.clsLAReviewHeading}>Changes Successful</h3>
       <div className={css.clsLAReviewPayTimelineContainer}>
         <div className={css.clsLAReviewPayTimeline}>
           <div className={css.clsLATimelineItem}>
             <div className={css.clsLATimelineDot}></div>
             <div className={css.clsLATimelineContent}>
               <div className={css.clsLATimelineHead}>
                 <h4 className={css.clsLATimelineLabel}>Today</h4>
               </div>
               <p className={css.clsLATimelineDescription}>{numberOfDaysFromToday(teamMember?.billDate)} days remaining for Team Member’s full-access privileges</p>
             </div>
           </div>
 
           <div className={css.clsLATimelineLine2TMdowngrade}></div>
           <div className={css.clsLATimelineItem}>
             <div className={css.clsLATimelineDot}></div>
             <div className={css.clsLATimelineContent}>
             <div className={css.clsLATimelineHead}>
               <h4 className={css.clsLATimelineLabel}>Starting {formatToLongDate(teamMember?.billDate)}</h4>
             </div>
             <p className={css.clsLATimelineDescription}>Team Member loses full-access privileges</p>
             </div>
           </div>  
         </div>
       </div>
 
     
     </div>
   )
 }
 


 export default withRouter(connect(null, {
  leaveMessagePopup: LeaveMessagePopup.open
})(TeamDowngrade));

// export default TeamDowngrade